import { duration } from 'moment';

export const tabConfig: Record<string, { label: string }> = {
  home: {
    label: 'Home',
  },
  discovery: {
    label: 'Discovery Coverage',
  },
  wrapping_up: {
    label: 'Wrapping Up',
  },
};

export const eventConfig: Record<
  string,
  {
    tab: keyof typeof tabConfig;
    color: string;
    displayParticipant?: boolean;
  }
> = {
  competitor_mention: {
    tab: 'home',
    color: '#fb8c00',
  },
  objection: {
    tab: 'home',
    color: '#fb8c00',
  },
  similar_question: {
    tab: 'home',
    color: '#fb8c00',
  },
  'breaking eye contact': {
    tab: 'home',
    color: '#e53935',
  },
  'face touching': {
    tab: 'home',
    color: '#e53935',
  },
  long_monologue: {
    tab: 'home',
    color: '#e53935',
  },
  high_talk_ratio: {
    tab: 'home',
    color: '#e53935',
  },
  discovery_coverage: {
    tab: 'discovery',
    color: '#3f51b5',
  },
  action_item: {
    tab: 'wrapping_up',
    color: '#3f51b5',
    displayParticipant: true,
  },
  pain_point: {
    tab: 'wrapping_up',
    color: '#fb8c00',
    displayParticipant: true,
  },
};

export const eventHighlightDuration = duration(1, 'minutes');

export const stringify = (str: string) =>
  str.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
